import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { removeStorage, setStorage } from '@/Util/auth';

Vue.use(Vuex);

const state = {
  user: {
    token:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNzY4MDU2NWZhNzcxZDZmZTcwZGYyMGFiYjhiZGJjNTllYjQ1ZGJjZThiMmM1NzgzYTk4M2U4MDBlOWQ3YjE1NGI0ZGQ2ZGE1NzE1NjJiOTUiLCJpYXQiOjE3MzAyMDM4MTcuMDY1Njg4LCJuYmYiOjE3MzAyMDM4MTcuMDY1NjksImV4cCI6MTc2MTczOTgxNy4wNjM0MTgsInN1YiI6IjgiLCJzY29wZXMiOltdfQ.uCB5GWbti5aEFSWENZVyXbR3ahR46Zw7z0dwxNaSzND3C4K3TqW3P1twjjpz675QL9F2KsIu_tTymiVFwlaxZNbzpuLM-dxijflDuN4K9I5F474EsO_aErxx4uY1Solb05alCf_O-BhiZ1Kvl8Oas6qvbI9K-CsDOrzjt8G0ko9wOFRap7OlGvDqq_ZOJkhlQ3wsN3iM0hTAae9DN7loEOzqm7XWHiAsf9AeY0vGZl6T2zri3W6iWdhjDlTE0R9m7wVJTbLBY4DHpMcptv2INF5u-6f_6SsxTCO2rJLBn0mEHTauQhTfsvslydTjW0PG9Mal2sSSzXT3PVtFNpJIlv-Gy7SSreGM0RIxW47P9uwRj6ibZOpca4ZxLi57wXRAGanjqPrEzJ3J7gkQumIHDnWWTtCcUgUP-pH24PO2CUkksqadOKK2_Ub7yOYikIxpAxI8OTCfG9M1hnJgzSNpDermbXPJrzmNUMTREbsb5nk8wGY-WHAueG8QRNMeHxux0gWJc8t-pJYdQYguhPNW-iYwglNjecPdcKl5tcNY7qAHmpRDl0wQCpEZN0Y1OplZJciJcJN7_QmAIb9Zl8jGdUb_vt-Fj7Hmznrhb9wpnrWIYJJyio8NbtZnTc32hFw4reBnH_kEiz2N4mE4tCQrWacVeVO6ioZjigETCrlfNgQ',

    full_name: 'Jalpa',

    phone: '+919510437123',

    email: 'jalpa1@gmail.com',

    role: 'user',
  },
  loader: false,
  validate: false,
  locale: 'en-US',
  isRTL: false,
  setDefaultLocale: 'en-Us',
  activeTab: 'completed',
  isUnAuthorized: false,
  isExpanded: true,
};

const store = new Vuex.Store({
  state,
  getters: {
    user: state => {
      return state.user;
    },
    loader: state => {
      return state.loader;
    },
    locale: state => {
      return state.locale;
    },
    validate: state => {
      return state.validate;
    },
    activeTab: state => {
      return state.activeTab;
    },
    getUnAuthorized: state => {
      return state.isUnAuthorized;
    },
  },
  actions: {
    user: (context, user) => {
      context.commit('user', user);
    },
    loader: (context, data) => {
      context.commit('LOADER', data);
    },
    setLoader: (context, data) => {
      context.commit('LOADER', data);
    },
    change_setting: (context, data) => {
      context.commit('CHANGE_SETTING', data);
    },
    setValidate: (context, data) => {
      context.commit('VALIDATE', data);
    },
    setActiveTab: (context, data) => {
      context.commit('activeTab', data);
    },
    setUnAuthorized: (context, data) => {
      context.commit('SET_UNAUTHORIZED', data);
    },
    setIsRTL: (context, data) => {
      context.commit('SET_IS_RTL', data);
    },
  },
  mutations: {
    toggleSidebar(state) {
      state.isExpanded = !state.isExpanded;
    },
    user: (state, user) => {
      state.user = user;
      if (state.user === null) {
        removeStorage('auth');
      }
    },
    LOADER: (state, data) => {
      state.loader = data;
    },
    CHANGE_SETTING(state, payload) {
      setStorage('locale', payload);
      state.locale = payload;
    },
    VALIDATE: (state, data) => {
      state.validate = data;
    },
    activeTab: (state, activeTab) => {
      state.activeTab = activeTab;
    },
    SET_UNAUTHORIZED: (state, data) => {
      state.isUnAuthorized = data;
    },
    SET_IS_RTL(state, data) {
      state.isRTL = data;
    },
  },
  plugins: [createPersistedState()],
});

export default store;
